export const getIcariusUrl = (slug: string) => {
  return `https://icarius.nl/${slug}`;
};

export const getIcariusProductUrl = (slug: string) => {
  return getIcariusUrl(`winkel/${slug}`);
};
